import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from './MainLayout';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { Button } from '@mui/material';

const ReportsList = () => {
  const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://pulse.marketersindemand.com';
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/api/reports?limit=20`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to load reports');
        setRows(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const onGenerate = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${apiBaseUrl}/api/reports/generate?lookback=14`, { method: 'POST' });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to generate');
      // Reload list and navigate to detail
      window.location.href = `/reports/${data.id}`;
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  if (loading) return <MainLayout title="Leadership Reports"><div style={{ padding: 24 }}>Loading...</div></MainLayout>;
  if (error) return <MainLayout title="Leadership Reports"><div style={{ padding: 24, color: '#dc2626' }}>{error}</div></MainLayout>;

  return (
    <MainLayout title="Leadership Reports">
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Button variant="contained" color="primary" size="small" onClick={onGenerate}>
            Generate now
          </Button>
        </div>
        <TableContainer component={Paper} className="enhanced-table" sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Generated</TableCell>
                <TableCell>Contracts</TableCell>
                <TableCell>On / Off</TableCell>
                <TableCell>Lookback</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{new Date(r.generated_at).toLocaleString()}</TableCell>
                  <TableCell>{r.contract_count}</TableCell>
                  <TableCell>{r.on_track_count} / {r.off_track_count}</TableCell>
                  <TableCell>{r.lookback_days}d</TableCell>
                  <TableCell align="right">
                    <Link to={`/reports/${r.id}`}>View</Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </MainLayout>
  );
};

export default ReportsList;


